/**
 * Foxhole war API icon type → image filename mapping.
 *
 * The `images` tuple is indexed by team:
 *   0 = neutral/none, 1 = COLONIALS, 2 = WARDENS
 */

interface MapIconDef {
  images: [string] | [string, string, string];
}

const ICON_MAP: Record<number, MapIconDef> = {
  5: { images: ['StaticBase1', 'StaticBase1Colonial', 'StaticBase1Warden'] },
  6: { images: ['StaticBase2', 'StaticBase2Colonial', 'StaticBase2Warden'] },
  7: { images: ['StaticBase3', 'StaticBase3Colonial', 'StaticBase3Warden'] },
  8: { images: ['ForwardBase1'] },
  9: { images: ['ForwardBase2'] },
  10: { images: ['ForwardBase3'] },
  11: { images: ['Medical', 'Medical', 'Medical'] },
  12: { images: ['VehicleFactory', 'VehicleFactoryColonial', 'VehicleFactoryWarden'] },
  13: { images: ['Armory'] },
  14: { images: ['SupplyStation'] },
  15: { images: ['Workshop'] },
  16: { images: ['ManufacturingPlant'] },
  17: { images: ['Refinery', 'RefineryColonial', 'RefineryWarden'] },
  18: { images: ['Shipyard', 'Shipyard', 'Shipyard'] },
  19: { images: ['TechCenter', 'TechCenterColonial', 'TechCenterWarden'] },
  20: { images: ['Salvage', 'Salvage', 'Salvage'] },
  21: { images: ['Component'] },
  22: { images: ['FuelField'] },
  23: { images: ['Sulfur'] },
  24: { images: ['WorldMapTent'] },
  25: { images: ['TravelTent'] },
  26: { images: ['TrainingArea'] },
  27: { images: ['Keep', 'Keep', 'Keep'] },
  28: { images: ['ObservationTower', 'ObservationTowerColonial', 'ObservationTowerWarden'] },
  29: { images: ['Fort'] },
  30: { images: ['TroopShip'] },
  32: { images: ['SulfurMine', 'SulfurMine', 'SulfurMine'] },
  33: { images: ['StorageFacility', 'StorageFacilityColonial', 'StorageFacilityWarden'] },
  34: { images: ['Factory', 'FactoryColonial', 'FactoryWarden'] },
  35: { images: ['Safehouse', 'SafehouseColonial', 'SafehouseWarden'] },
  36: { images: ['AmmoFactory', 'AmmoFactory', 'AmmoFactory'] },
  37: { images: ['RocketSite', 'RocketSite', 'RocketSite'] },
  38: { images: ['SalvageMine', 'SalvageMine', 'SalvageMine'] },
  39: { images: ['ConstructionYard', 'ConstructionYardColonial', 'ConstructionYardWarden'] },
  40: { images: ['ComponentMine', 'ComponentMine', 'ComponentMine'] },
  41: { images: ['OilWell', 'OilWell', 'OilWell'] },
  45: { images: ['RelicBase', 'RelicBaseColonial', 'RelicBaseWarden'] },
  46: { images: ['RelicBase', 'RelicBaseColonial', 'RelicBaseWarden'] },
  47: { images: ['RelicBase', 'RelicBaseColonial', 'RelicBaseWarden'] },
  51: {
    images: [
      'MassProductionFactory',
      'MassProductionFactoryColonial',
      'MassProductionFactoryWarden',
    ],
  },
  52: { images: ['Seaport', 'SeaportColonial', 'SeaportWarden'] },
  53: { images: ['CoastalGun', 'CoastalGunColonial', 'CoastalGunWarden'] },
  54: { images: ['Soul Factory', 'Soul FactoryColonial', 'Soul FactoryWarden'] },
  56: { images: ['TownBaseTier1', 'TownBaseTier1Colonial', 'TownBaseTier1Warden'] },
  57: { images: ['TownBaseTier2', 'TownBaseTier2Colonial', 'TownBaseTier2Warden'] },
  58: { images: ['TownBaseTier3', 'TownBaseTier3Colonial', 'TownBaseTier3Warden'] },
  59: { images: ['StormCannon', 'StormCannonColonial', 'StormCannonWarden'] },
  60: { images: ['IntelCenter', 'IntelCenterColonial', 'IntelCenterWarden'] },
  61: { images: ['Coal', 'Coal', 'Coal'] },
  62: { images: ['Fuel', 'Fuel', 'Fuel'] },
  70: { images: ['RocketTarget', 'RocketTarget', 'RocketTarget'] },
  71: { images: ['RocketCrater', 'RocketCrater', 'RocketCrater'] },
  72: {
    images: [
      'RocketSiteWithRocketMapIcon',
      'RocketSiteWithRocketMapIcon',
      'RocketSiteWithRocketMapIcon',
    ],
  },
  75: { images: ['FacilityMineOilRig', 'FacilityMineOilRig', 'FacilityMineOilRig'] },
  88: { images: ['AircraftDepot'] },
  89: { images: ['AircraftFactory'] },
  90: { images: ['AircraftRadar'] },
  91: { images: ['AircraftRunwayT1'] },
  92: { images: ['AircraftRunwayT2'] },
};

export function getFoxholeIconUrl(iconType: number, teamId: string | null): string | null {
  const def = ICON_MAP[iconType];
  if (!def) return null;
  let teamIndex = 0;
  if (teamId === 'COLONIALS') teamIndex = 1;
  else if (teamId === 'WARDENS') teamIndex = 2;
  const name = def.images[teamIndex] ?? def.images[0];
  return `/mapicons/MapIcon${name}.png`;
}
